import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';

type WikiMarkdownProps = {
  content: string;
};

export function WikiMarkdown({ content }: WikiMarkdownProps) {
  return (
    <div className="wiki-markdown">
      <Markdown remarkPlugins={[remarkGfm]} skipHtml>
        {content}
      </Markdown>
    </div>
  );
}
